var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PrimaryButton',{staticClass:"o-primary-btn--modal-close c-modal__close-btn",on:{"click":_vm.emitClick}},[_vm._v(" × ")])}
var staticRenderFns = []

export { render, staticRenderFns }